/**
 * Adapts the signed-in user's stored preferences to the shape @mmm/ui's
 * ThemeProvider persists through.
 *
 * The design system deliberately has no notion of a session — the public site
 * uses its browser-local default instead — so the server-backed behaviour is
 * supplied here and passed in as a prop.
 */
import { useCallback, useMemo } from "react";
import { usePreferences } from "./usePreferences.js";
import { type ThemeMode, type ThemePersistence } from "@mmm/ui";

export function useServerTheme(): ThemePersistence {
  const { preferences, loaded, save } = usePreferences();

  const persist = useCallback(
    (mode: ThemeMode) => {
      void save({ theme: mode });
    },
    [save]
  );

  return useMemo(
    () => ({ mode: preferences.theme ?? null, loaded, save: persist }),
    [preferences.theme, loaded, persist]
  );
}
